"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHmacSecret = exports.resetHmacSecretCache = void 0;
const secrets_layer_client_1 = require("@eventbrite/secrets-layer-client");
const constants_1 = require("./constants");
let hmacSecret = process.env?.[constants_1.SECRET_ENV_NAME] || null;
const resetHmacSecretCache = () => {
    hmacSecret = null;
};
exports.resetHmacSecretCache = resetHmacSecretCache;
const getHmacSecret = async () => {
    if (hmacSecret) {
        return hmacSecret;
    }
    try {
        const response = await (0, secrets_layer_client_1.getSecret)(constants_1.CSRF_HMAC_SECRET_NAME);
        if (response?.SecretString) {
            hmacSecret = response.SecretString;
        }
        else {
            hmacSecret = constants_1.SECRET_NOT_FOUND_ERROR_MESSAGE;
        }
    }
    catch (error) {
        hmacSecret = constants_1.SECRET_MANAGER_ERROR_MESSAGE;
        console.error(constants_1.SECRET_MANAGER_ERROR_MESSAGE, error);
    }
    return hmacSecret;
};
exports.getHmacSecret = getHmacSecret;
//# sourceMappingURL=getHmacSecret.js.map